export default __webpack_public_path__ + "static/media/couple-painting-new-house.69ec1b56.svg";